export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "Tidak ada data",
    "notifications.rp_has_been_updated": "Proyek Pemukiman telah diperbarui",
    "moduleTitle.files": "file/dokumen",
    "label.coordinator": "Coordinator",
    "sidebar.translations_managment": "",
    "table.file": "File",
    "label.report_overview": "",
    "label.parent_agreement": "Persetujan Ortu",
    "parentalConsent.i_consent_to_and_understand_that": "6. Saya setuju dan memahami bahwa fotografi yang mungkin didokumentasikan oleh peserta pada kegiatan tertentu sehubungan dengan Award dan beberapa foto mungkin saja digunakan untuk tujuan promosi program Award, hal ini akan dilaksanakan dengan formulir serah terima yang baik yang ditandatangani oleh kedua pihak peserta dan para orang tua/wali.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Saya memahami bahwa peserta diwajibkan patuh pada persyaratan Award yang tertera dalam Record Book atau ORB, kebijakan dan standard dari perilaku Operator Award (yang bertambah dari waktu ke waktu) dan persyaratan dari Award Centre sehubungan dengan rencana pengelolaan kondidi gawat darurat, penilaian kegiatan dan tatacara pelaksanaan Perjalanan Petualangan, dan memahami sepenuhnya bahwa Award Centre sewaktu waktu dapat menarik persetujuannya apabila ternyata peserta tidak memenuhi persyaratan yang disepakati.",
    "table.end_date": "Tanggal Akhir",
    "label.activation_date": "Tanggal aktifasi",
    "label.report": "",
    "label.award_is_offline": "Award Offline",
    "label.pending_changes": "Perubahan yang ditunda",
    "errors.min_nights_required": "Minimum jumlah malam yang diwajibkan",
    "label.country": "Negara",
    "notifications.award_leader_has_been_returned": "Award leader telah dikembalikan",
    "notifications.participant_has_been_updated": "Perserta telah diperbarui",
    "label.phone_number": "Nomor Telpon",
    "roles.aj_assessor": "Assesor Perjalanan Petualangan",
    "notifications.person_state_has_been_changed": "Nama person telah diubah",
    "pageTitle.dashboard": "Dashboard",
    "moduleTitle.global_payment_method": "Metode pembayaran global",
    "label.organization_type": "Jenis organisasi",
    "button.account_settings": "Pengaturan Akun",
    "notifications.contact_has_been_updated": "Kontak telah di upadate",
    "participant.recover_password": "Kata Sandi dapat digunakan",
    "notifications.assessment_request_has_been_sent": "permohonan assessment telah dikirim",
    "button.unassign": "",
    "label.start_date": "Waktu dimulai",
    "label.assign_labels": "",
    "sidebar.participants": "Peserta",
    "roles.coordinator": "Coodinator",
    "label.organization_contact": "Kontak dalam Organisasi",
    "tabs.customization": "Penyesuaian / Kustomisasi",
    "sidebar.award_units": "Award Centre",
    "button.change_goal": "Rubah Tujuan",
    "translationsManagement.selectProject": "Pengaturan terjemahan pilih Project",
    "award.rp": "Proyek Pemukiman",
    "label.size": "Ukuran",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "Kegiatan telah disetujui",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "Kirim kembali permohonan penilaian",
    "notifications.template_has_been_removed": "Template telah dihapus",
    "button.award_settings": "Pengaturan Award",
    "pageTitle.payment": "Pembayaran",
    "tasks.return_award": "Award dikembalikan",
    "label.link": "Link",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "Kantor Regional - daftar kontak",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Bidang kegiatan disetujui",
    "table.logs": "Catatan",
    "moduleTitle.remove_file": "Hapus file",
    "label.email_confirmed": "Konfirmasi email",
    "notifications.activity_has_been_returned": "Kegiatan telah dikembalikan",
    "label.note": "Catatan",
    "button.show": "",
    "tabs.adventurous_journey": "Perjalanan Petualangan",
    "sidebar.my_todolist": "",
    "label.here": "Disini",
    "organisation.change_award_mode": "Ubah Jenis Award",
    "table.note_from_al": "Catatan dari Award Leader",
    "label.gender": "Gender",
    "moduleTitle.remove": "Hapus?",
    "errors.must_be_less_than": "Wajib kurang dari (batas ttt)",
    "button.logout": "Keluar",
    "label.no_selected_participants": "Tidak ada peserta yang dipilih",
    "button.new_aj_event": "Kegiatan Perjalanan Petualangan baru",
    "label.employement_status": "Status pekerjaan",
    "tabs.logs": "Catatan",
    "tabs.contacts": "Kontak",
    "label.option": "opsi/pilihan",
    "dashboard.charts": "Bagan",
    "notifications.rp_has_been_approved": "Proyek Pemukiman telah disetujui",
    "pageTitle.new_participant": "Peserta baru",
    "notifications.award_leader_has_been_approved": "Award LEader telah di setujui",
    "moduleTitle.would_you_like_to_remove_leader_training": "Apakah anda akan menghapus Award Leader Training?",
    "moduleTitle.update_configuration_value": "Perbaharui nilai konfigurasi",
    "table.description": "Penjelasan",
    "table.organization": "Organisasi",
    "label.youtube": "Youtube",
    "label.author": "Penulis",
    "table.suitable_for_award_level": "Cocok untuk Tingkat Award",
    "label.content_update": "Mohon tunggu. Sedang mengupdate konten",
    "notifications.new_question_has_been_added": "tidak ada pertanyaan yang ditambahkan",
    "pageTitle.nao_awards": "Kantor Nasional - Award\n",
    "table.last_name": "Nama belakang",
    "moduleTitle.adventurous_journey_detail": "Detail Perjalanan Petualangan",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "Lokasi Proyek",
    "label.email_help_award_level": "",
    "label.date": "Tanggal",
    "label.previous_completed_award_place": "Dimana",
    "button.show_more": "Perlihatkan lebih banyak lagi",
    "label.wwc_number": "Nomor WWC",
    "button.filter": "Saring",
    "notifications.rp_has_been_returned": "Proyek Pemukikan telah dikembalikan",
    "pageTitle.residetial_project_assessor_report": "Proyek Pemukiman - Laporan Assessor",
    "label.generating": "Sedang menggenerate tabel",
    "moduleTitle.finance_system_data": "Data Sistem Keuangan",
    "notifications.adventurous_journey_state_has_been_changed": "Status perjalanan bertualang telah diubah",
    "route.levels": "Tingkatan",
    "moduleTitle.activity_leader": "Award Leader",
    "tasks.approve_event": "Acara disetujui",
    "tasks.reject_event": "Event dikembalikan",
    "table.region": "Wilayah",
    "pageTitle.nao_award_leaders": "Kantor Nasional -  Award Leader",
    "errors.must_be_at_least": "Paling tidak min {min} karakter",
    "table.title": "Titel",
    "table.last_activity": "Kegiatan terakhir",
    "tasks.delete_registration": "Hapus Pendaftaran",
    "table.date_time": "Tanggal/Waktu",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Award Operatpr menyatakan komitmen nya untuk menghormati kerahasiaan anda. Informasi pribadi di kumpulkan utnuk tujuan berpartisipasi dalam program Award. Para peserta yang tidak memberikan informasinya tidak diperkenankan ikut dalam Award (catatan tidak berlaku bagi para peserta yang tidak memberikan data). Kami mungkin akan menggunakan informasi pribadi mu untuk mengirimkan informasi mengenai kegiatan Award atau acara yang kami percayai menjadi minatmu, Kami dapat membuka informasi ini kepada organisasi lokal atau international dan para penyedia jasa yang membantu kami untuk mengoperasikan dan mengadministrasikan program Award. Apabila kamu bersedia untuk menghubungi kami atau ingin akses pada informasi pribadi mu silahkan menulis surat kepada Award Operator. Kamu juga dapat menghubungi Award Operator untuk meminta salinan dari kebijakan kerahasiaan mereka.",
    "aj.practice_journey": "Perjalanan latihan",
    "notification.log_has_been_restored": "Catatan kegiatan telah disimpan",
    "tabs.my_participants": "Daftar peserta dalam bimbingan saya",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Supervisor",
    "moduleTitle.your_parental_consent": "Persetujuan orang tua",
    "route.registration_participants": "Registrasi peserta",
    "placeholder.start_typing": "Mulai mengetik",
    "tasks.approve_award": "Award disetujui",
    "route.registrations": "Pendaftaran",
    "button.add_activity": "",
    "notifications.aj_event_has_been_created": "Kegiatan Perjalanan Petualangan telah dibuat",
    "states.supervisor_approval": "Persetujuan Assessor",
    "label.description": "Penjelasan",
    "button.leave_anyway": "Tinggalkan halaman",
    "tabs.registrations": "Pendaftaran",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "Notifikasi terjemahan telah dimutakhirkan. button",
    "pageTitle.nao_registration": "Pendaftaran Kantor Nasional",
    "pageTitle.mro_logs": "Kantor Regional - Logs",
    "meta.page_not_found": "Halaman tidak ditemukan",
    "label.bulk_action_unsuccessful": "",
    "global.days": "hari hari",
    "table.review": "Kajian",
    "table.as_assessor_for": "Sebagai Assessor untuk ",
    "roles.if_staff_statistical_user": "Bila Staf User",
    "table.levels": "Tingkat",
    "label.suitable_for_level": "Memenuhi untuk tingkat",
    "pageTitle.leaders": "Leader",
    "moduleTitle.send_test_email": "Kirim Email Percobaan (Test)",
    "pageTitle.tasks_removed_registration": "Hapus Registrasi Peserta",
    "label.you_will_be_forced_to_login_again_after_change": "Anda akan dipaksa untuk login kembali setelah perubahan terjadi",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "Persetujuan atas bidang kegiatan",
    "pageTitle.payments": "Pembayaran",
    "global.nights": "malam malam",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "Pilih organisasi",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "Upload berkas",
    "label.migrated_contact_email": "Email kontak telah di migrasikan",
    "label.for_award_unit": "Untuk Award Centre",
    "label.aj_template_note": "catatan",
    "table.last_log_added": "",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "harap berikan komentar pada kolom perbaikan/kinerja/komitmen peserta",
    "label.consent_already_given_login": "Persetujuan telah diberikan. Silahkan login sebagai putra anda",
    "participant.level_start_date": "{value} tanggal mulai",
    "sidebar.my_region_office": "Kantor Regional",
    "states.section_signoff": "Bidang disetujui",
    "moduleTitle.assessor_details": "Rincian Assessor",
    "moduleTitle.adventurous_journey_settings": "Pengaturan Perjalanan Petualangan",
    "moduleTitle.note_from_al": "Catatan dari Award Leader",
    "button.add_role": "Tambahkan peran",
    "table.run": "Lari",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "Panduan aplikasi user - Award Leader",
    "tabs.section_approval": "Bidang kegiatan disetujui",
    "roles.award_verifier": "Award verififier",
    "tabs.activity_approval": "Kegiatan disetujui",
    "logs.add_log": "Tambah catatan",
    "tabs.award": "Award",
    "notifications.this_role_has_read_only_persmission": "Peran ini memiliki ijin read-only",
    "table.no_filtered_results": "Tidak ada hasil",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "Info mengenai Lokasi Proyek",
    "label.optional": "Opsional",
    "errors.do_not_match": "Tidak sesuai",
    "label.use_comma_for_multiple_entries": "Gunakan tanda koma untuk multiple enteries,",
    "label.operating_authority": "Otorita Operasi",
    "label.activity_section": "Bidang kegiatan",
    "notifications.you_have_been_logged_out": "Kamu telah berhasil keluar",
    "table.finished": "Selesai",
    "button.same_as_billing": "Sama dengan Tagihan",
    "table.payment": "Pembayaran",
    "table.current_level": "Tingkat saat ini",
    "button.view_nao": "",
    "table.email_confirmation": "Email Konfirmasi ",
    "moduleTitle.shipping_address": "Alamat pengiriman barang",
    "label.secondary_phone_type": "Jenis telepon kedua",
    "notifications.saved": "Simpan",
    "pageTitle.all_participants": "Seluruh Peserta",
    "label.first_name": "Nama Depan",
    "label.oa_price": "Harga berlaku untuk OA",
    "table.award_mode": "Mode Award",
    "tabs.api_keys": "Api Keys",
    "award.award_detail": "Info Lengkap Award",
    "tabs.user_management": "Pengelolaan User",
    "tabs.all_events": "Semua acara",
    "notifications.history_record_has_been_removed": "Catatan lama telah dihilangkan",
    "award.no_data": "Tidak ada data",
    "notifications.preparation_training_has_been_added": "Persiapan dan Pelatihan telah ditambahkan",
    "label.message": "Pesan",
    "notifications.participant_info_updated": "Informasi peserta telah diperbaharui\n",
    "roles.nao_staff": "Staf Kantor Nasional",
    "tabs.adventurous_journeys": "Perjalanan Petualangan",
    "label.gops": "",
    "route.upload": "Upload",
    "notifications.history_record_has_been_added": "Catatan lama telah ditambahkan",
    "notifications.history_record_has_been_updated": "Catatan lama telah diperbaharui",
    "label.no_data": "Tidak ada data",
    "button.add_coordinator": "Tambahkan Coordinator",
    "label.you_are_already_logged_as": "Kamu sudah tercatat sebagai:",
    "route.my_national_office": "Kantor Nasional dinegara saya",
    "tabs.leaders": "Para Leader",
    "label.email_confirmation": "konfirmasi email",
    "table.registration_date": "Tanggal Pendaftaran",
    "notifications.role_has_been_removed": "Peran telah dihapuskan",
    "button.move": "Pindah",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "rinci",
    "table.award_unit": "Award Centre",
    "sidebar.settings": "Pengaturan",
    "dashboard.leader_state": "Leader per negara",
    "notifications.award_unit_has_been_approved": "Award Centre telah disetujui",
    "states.awaiting_approval": "Menunggu persetujuan",
    "table.level": "Tingkat",
    "table.action_requested": "",
    "label.organisation_mode": "Jenis organisasi",
    "label.no_note": "Tidak ada catatan",
    "tabs.my_events": "Acara ku",
    "notifications.participants_have_been_added": "Peserta telah ditambahkan",
    "tabs.registration_questions": "",
    "button.delete_registration": "Hapus Registrasi",
    "notifications.parental_consent_link_has_been_sent": "Link Persetujuan Ortu telah di kirimkan",
    "moduleTitle.select_role_organization": "Pilih peran dan organisasi",
    "label.experience": "Pengalaman",
    "translationsManagement.modal.title": "Pengaturan terjemahan capital title",
    "table.ic": "Independent Country",
    "table.id": "Identity",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "Apakah kamu ingin menghapus akun ini ",
    "table.fields_included": "",
    "label.user_guide_web_leader": "User web guide - Award Leader",
    "label.journey_type": "Jenis Perjalanan",
    "button.setup": "Setup",
    "tabs.my_national_office": "Kantor Award Nasional",
    "notifications.training_has_been_removed": "Pelatihan telah dihapuskan",
    "label.nominated_and_identified_persons": "Nominasikan dan identifikasikan nama yang dapat melihat semua data namun tidak dapat mengubahnya",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "anda telah keluar dari sistem karena tidak aktif",
    "states.award_leader_signoff": "Persetujuan Award Leader",
    "table.award_signoff_attempts": "Award disetujui",
    "sidebar.regions": "Wilayah",
    "label.activity_deleted_note": "Kegiatan ini telah dihapus. Anda dapat menyimpannya dengan mengklik tombol dibawah ini.",
    "table.total": "Total",
    "errors.a_problem_has_occured_during_processing": "Masalah telah terjadi selama proses, lihat informasi lain",
    "participant.participant_already_has_gold_award": "Peserta telah memperoleh Award Emas",
    "pageTitle.mro": "Kantor Regional",
    "notifications.authorization_code_has_expired": "Kode Otorisasi habis masa berlaku",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "Perjalanan Petualangan",
    "global.loading": "Loading",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "Registrasi",
    "label.any_string": "Any string",
    "contact.change_contact_status": "Ubah Status Contact",
    "tabs.registration": "Pendaftaran",
    "label.override_payment_note": "Membatalkan catatan keuangan",
    "notifications.section_has_been_signed_off": "Bidan kegiatan telah disetujui",
    "label.payment_date": "Tanggal pembayaran",
    "button.approve": "Setuju",
    "moduleTitle.loggin_in": "Masuk Logging in",
    "label.website": "Website",
    "label.role": "Peran",
    "table.assessor_report": "Laporan Assessor",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Pernah menjadi Assessor sebelumnya",
    "pageTitle.registrations": "Registrasi",
    "parentalConsent.this_form_must_be_completed": "Formulir ini wajib di lengkapi oleh Orang Tua / Wali dari peserta yang berusia dibawah 18 tahun atau umur yang dimaksud oleh negara masing masing sebagai batas usia dimana seseorang untuk memiliki tanggung jawab secara hukum",
    "button.apply": "",
    "errors.include_at_least_one_number": "teridiri dari paling tidak satu karakter angka",
    "label.content_restore": "Sesi Penyegarah",
    "logs.hour": "jam",
    "parentalConsent.i_have_read_and_understand": "7. Saya telah membaca dan memahami berbagai tingkat dan persyaratan dari Award sebagaimana telah dihabarkan dalam garis besar dari Award (halaman 4 dari formulir ini)",
    "notifications.award_was_deleted": "",
    "label.journey_category": "Jenis Perjalanan",
    "notifications.search_cancelled": "Pencarian terganggu, anda perlu menunggu sampai proses selesai",
    "route.detail": "Info lengkap",
    "route.user_guide": "User guide",
    "moduleTitle.history": "Sejarah",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Peserta yang belum mendapat Award Leader",
    "states.inactive": "Tidak Aktif",
    "pageTitle.search_results": "Hasil Pencarian",
    "button.proceed_to_login": "Lanjutkan login",
    "pageTitle.assessor_report_reject": "Pengembalian Laporan Assessor ",
    "notifications.contact_has_been_removed": "Kontak telah dihapus",
    "sidebar.operating_authorities": "Otoritas Operasi",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "Persiapan dan Pelatihan",
    "route.user_guide_web_leader": "User web guide - Award Leader",
    "label.position_in_organization": "Posisi dalam Organisasi",
    "errors.emails_dont_match": "email tidak cocok",
    "route.my_participants": "Daftar peserta yang saya bimbing",
    "pageTitle.customisations": "Penyesuaian",
    "tabs.localization_files": "File Lokalisasi",
    "table.assessor_approval": "Persetujuan Assessor",
    "tabs.related_contacts": "Kontak pihak yang terkait",
    "table.aus": "Para Award Centre",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "Nilai nilai yang mungkin muncul",
    "label.if_your_download_doesnt_start": "Bila proses donlot tidak terjadi secara otomatis, mohon klik disini",
    "route.independent_award_centres": "Independent Award Centers ",
    "pageTitle.user_guide": "user Guide",
    "button.visit": "",
    "label.hours_first_letter": "h (jam)",
    "pageTitle.my_organization_detail": "Organisasi ku - Perincian",
    "pageTitle.nao_detail": "Info lengkap mengenai Kantor Award Nasional",
    "button.change": "Ubah",
    "award.aj": "Perjalanan Petualangan",
    "table.award_state": "Award",
    "pageTitle.tasks_award_signoff": "Program Award disetujui",
    "pageTitle.regions": "wilayah",
    "notifications.award_has_been_signed_off": "Award telah disetujui",
    "dashboard.award_approved_by": "Award yang disetujui per level tahun 2016",
    "tabs.new_template": "Template baru",
    "error.parent_email_must_be_filled": "Email orang tua wajib di simpan",
    "label.organisation_invoicing_name": "Nama Organisasi untuk keperluan Penagihan",
    "pageTitle.related_contacts": "Kontak pihak yang berhubungan",
    "button.try_again": "Perhatian dan coba lagi",
    "label.cannot_be_change_to_another": "Tidak dapat di ubah ke tingkat Award lainnya",
    "notifications.lead_coordinator_has_been_set": "Pimpinan Coordinator baru telah ditetapkan",
    "label.training_name": "Nama Training (Pelatihan)",
    "moduleTitle.new_contact": "Kontak baru",
    "translationsManagement.modal.updateTitle": "Pengaturan terjemahan capital update Title",
    "moduleTitle.offline_award_units_signoff": "Persetujuan Leader - offline",
    "notifications.award_level_has_been_changed": "Tingkatan Award telah di rubah",
    "label.subject": "Perihal",
    "route.silver_level": "Tingkat Perak",
    "label.privacy_notice": "",
    "label.switch_organization": "Ganti Organisasi",
    "meta.dofe_name": "The Duke of Edinburgh's International Award",
    "route.profile": "Profil",
    "roles.super_user": "Super user",
    "dashboard.while_you_were_gone": "Apabila kamu sedang tidak ditempat",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "Nama Tengah",
    "moduleTitle.new_activity": "Kegiatan baru",
    "organisation.would_you_like_to_remove": "Apakah anda ingin menghilangkan organisasi ini",
    "label.state_province": "Nagara / Provinsi/ Region",
    "moduleTitle.your_home_address": "Alamat rumah anda",
    "tabs.sign_offs": "disetujui",
    "moduleTitle.logs": "Catatan",
    "button.view_more": "Lihat lebih banyak",
    "label.profile": "Profil",
    "label.title": "Titel",
    "tabs.award_signoff": "Award Disetujui",
    "label.post_code": "Kode Pos",
    "states.ceremony_certificate": "Upacara dan Sertifikat",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "Saya setuju dengan penyediaan semua informasi personal yang telah diberikan (termasuk data peserta)  kepada Award Centre dan Award Operator. Saya setuju bahwa informasti ini akan diperlakukan sesuai dengan kebijakan kerahasiaan yang dianut oleh Award Operator (yang disesuaikan dari waktu ke waktu), Prisip Kerahasiaan yang berlaku secara nasional dalam UU perlindungan data  (di negara Inggris Raya) tahun 1988 (atau UU yang secara lokal setara dengan hal ini) dan berbagai peraturan, standar, panduan atau instruksi mengenai kerahasiaan yang mengikat dibawah peraturan mengenai kerahasiaan.",
    "label.user_guide_web_participant": "User web guide - Peserta",
    "label.award_unit_type": "Jenis Award Centre",
    "states.complete": "",
    "table.participant_state": "Peserta",
    "pageTitle.my_organization_payment": "Organisasi ku  - Pembayaran",
    "table.approved": "Disetujui",
    "pageTitle.my_organization_contacts": "Organisasi ku - kontak",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "Rubah menjadi ",
    "label.integer": "Integer",
    "notifications.translationUpdateInterrupted": "Notifikasi Terjemahan diterrupsi",
    "notifications.password_has_been_changed": "kata sandi telah dirubah",
    "button.invite_assessor": "Undang Assessor",
    "label.other_activity": "Kegiatan lainnya",
    "notifications.parental_consent_has_been_sent": "Persetujuan Orang Tua/Wali telah dikirim",
    "button.revise": "Perbaiki",
    "errors.end_date_must_be_after_start_date": "Tanggal akhir wajib setelah tanggal awal",
    "label.award_leader_signoff_date": "Tanggal persetujuan Award Leader",
    "parentalConsent.i_understand_every_participant_must": "8.2 Saya memahami setiap peserta wajib berpartisipasi dalam kegiatan Award melalui Award Centre yang memiliki hak sepenuhnya untuk menerima atau menolak peserta dan usulan kegiatan untuk dilaksanakan sebagai bagian dari program Award.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Perjalanan Petualangan",
    "global.day": "hari",
    "moduleTitle.coordinator": "Coordinator",
    "label.region": "Regional",
    "button.add_history_record": "Tambahkan catatan sejarah",
    "moduleTitle.adventurous_journey_template_settings": "Pengaturan Template Perjalanan Petualangan",
    "notifications.personal_details_have_been_updated": "Info pribadi telah diperbarui",
    "sidebar.ics": "Independent Countries (GBT)",
    "table.independent_award_centre": "Independent Award Centre",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "Waktu UTC\n",
    "moduleTitle.emails": "Email",
    "label.backoffice": "label.backoffice",
    "moduleTitle.parent_consent": "Persetujuan Orang Tua/ Wali",
    "label.photo_consent_given": "Peserta setuju -bila foto profilenya  digunakan untuk tujuan promosi",
    "moduleTitle.authorising_contact": "Contact yang memiliki otorisasi",
    "label.assessment_with_role": "penilaian (peran) ",
    "dashboard.type_of_awards": "Jenis Award Centre",
    "moduleTitle.payment": "Pembayaran",
    "states.in_progress": "Dalam progres",
    "logs.no_logs": "Tidak ada catatan",
    "sidebar.my_office": "My Office",
    "label.assessor_report": "Laporan Assessor",
    "notifications.rp_has_been_signed_off": "Proyek Pemukiman telah disetujui",
    "tabs.labels": "",
    "sidebar.payments": "Pembayaran",
    "meta.profile_questions": "pertanyaan mengenai Profil",
    "label.fax": "Faks",
    "label.email_help_custom_link": "",
    "label.last_name": "Nama Belakang",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "Peserta per tingkat Award",
    "tabs.award_leaders": "Para Award Leader",
    "label.i_confirm_that_ive_witnessed": "Saya mengkonfirmasi bahwa saya telah menyaksikan buku kerja Peserta untuk kegiatan berikut ini:",
    "table.lead_coordinator": "",
    "states.deleted": "Hapus",
    "label.no_answers": "Tidak ada jawaban",
    "button.add": "Tambah",
    "label.exchequer_number": "No Cheque / No Account",
    "label.waiting": "Menunggu",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "Pendaftaran dikembalikan",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "Persetujan Orang Tua",
    "table.assessor_approve": "Persetujuan Assessor",
    "errors.some_fields_requires_your_attention": "Beberapa kolom memerlukan perhatian mu",
    "aj.qualifying_journey": "Perjalanan Kualifikasi",
    "route.awards": "Award Award",
    "table.registration": "Pendaftaran",
    "pageTitle.assessors": "Assessors",
    "notifications.award_has_been_updated": "Award telah berhasil di update",
    "errors.must_be_one_of": "Wajib merupakan salah satu dari: {enum}",
    "pageTitle.logs": "Catatan",
    "notifications.notifications.invitation_has_been_sent": "Undangan telah dikirimkan",
    "route.national_offices": "Kantor Nasional di negara lain",
    "notifications.training_has_been_updated": "Pelatihan telah diperbarui",
    "label.parent_last_name": "Nama belakang Ortu/Wali",
    "table.leaders": "Leader",
    "states.award_level_complete": "Tingkatan Award Selesai",
    "button.reset": "Reset",
    "sidebar.my_award_unit": "Award Centre saya",
    "pageTitle.all_aj_events": "Kegiatan Perjalanan Petualangan semua peserta",
    "label.activity": "Kegiatan",
    "moduleTitle.are_you_sure": "Yakin?",
    "route.gold_level": "Tingkat Emas",
    "table.evidence": "Bukti",
    "label.delivery_confirmed": "Pengiriman telah dikonfirmasi",
    "parentalConsent.as_the_parent": "Sebagai orang tua/wali, saya memberikan persetujuan bahwa seluruh gambar dan image dapat digunakan oleh Yayasan untuk keperluan promosi Award.",
    "label.awardMode.offline": "Offline",
    "tasks.approve_registration": "Persetujuan Pendaftaran",
    "note.change_the_email_will_change": "Catatan: Merubah email dapat merubah email yang telah dimigrasikan",
    "notifications.participant_has_been_approved": "Peserta telah disetujui",
    "label.reached_activity_limit": "Batas kegiatan telah dicapat dalam bidang kegiatan ini. Peserta dapat melakukan maksimum kegiatan dalam setiap bidang.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Persiapan dan Pelatihan telah di hapus",
    "pageTitle.settings": "Pengaturan",
    "participant.level_registration_date": "{value} Tanggal Registrasi",
    "notifications.question_has_been_removed": "pertanyaan telah dihapuskan",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "Leader",
    "notifications.participants_have_been_transferred": "Peserta telah di alihkan",
    "tabs.assessors": "Assessors",
    "sidebar.dashboard": "Panel",
    "pageTitle.independent_award_centers": "Independent Award Center",
    "label.search": "Telusuri",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "Catatan dari peserta",
    "errors.required_field": "Wajib diisi",
    "tasks.approve_task": "Kegiatan yang disetujui",
    "logs.edit_log": "Ubah catatan",
    "table.state": "Negara",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "Tutup",
    "label.parent_first_name": "Nama depan Ortu/Wali",
    "parentalConsent.i_understand_that_the_participant": "1. Saya memahami bahwa peserta tidak dapat berpartisipasi dalam program Award sampai formulir ini dilengkapi (termasuk didalamnya persetujuan orang tua/wali) dan dikembalikan kepada Penyelenggara Award masing masing dengan biaya pendaftaran dan telah disetujui oleh Award Centre",
    "tabs.award_units": "Para Award Centre",
    "table.hours": "jam",
    "label.type": "Jenis",
    "notifications.adventurous_journey_has_been_removed": "Perjalanan Petualangan telah dihapus",
    "label.aj_is_not_approved_yet": "Perjalanan Petualangan belum disetujui",
    "roles.authorizing_contact": "Contact yang memiliki otorisasi",
    "table.date_submitted_to_office_signoff": "tanggal penyerahan pada Kantor Award untuk mendapat persetujuan",
    "notifications.section_has_been_returned": "Bidang kegiatan telah dikembalikan",
    "table.created_by": "Dibuat oleh",
    "route.user_guide_web_participant": "User web guide - Peserta",
    "route.templates": "Template",
    "states.awaiting_sign_off": "Persetujuan Award Leader",
    "table.phone": "Telephone",
    "label.parental_consent": "Persetujuan Ortu",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "Tingkat Perunggu",
    "label.invoice_currency": "Mata Uang ",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "Server tidak dapat di jangkau saat ini. Mohon coba kembali. Apabila problem masih ditemui, harap hubungi tim support kami.",
    "notifications.contact_has_been_created": "Kontak telah dibuat",
    "pageTitle.profile_questions": "Pertanyaan",
    "table.observation_files": "Berkas observasi",
    "table.participants": "Para peserta",
    "tasks.no_evidence": "Tidak ada bukti disediakan",
    "button.edit": "Edir",
    "moduleTitle.leader": "Leader",
    "notifications.new_template_has_been_updated": "Template baru telah diperbarui",
    "table.name": "Nama",
    "label.no_results": "Tidak ada hasil",
    "moduleTitle.documents": "Dokumen",
    "button.invite": "Undang",
    "label.goal": "Tujuan",
    "pageTitle.nao_award_units": "Kantor Nasional - Award Centre",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "Min (panjang) karakter",
    "label.email_help_note": "",
    "label.person_status.activating": "label.person_status.aktifasi",
    "moduleTitle.remove_role": "ingin meremove Oil?",
    "label.total": "Total",
    "label.delete_participant_award_info": "",
    "route.leaders": "Leader",
    "table.start_date": "Tanggal Mulai",
    "moduleTitle.coordinators": "Coordinator",
    "button.create": "Buat",
    "tabs.awards": "Award",
    "parentalConsent.form_has_been_sent": "Persetujuan orang tua/wali telah dikirimkan",
    "states.journey_approval": "Persetujuan untuk Perjalanan Petualangan",
    "pageTitle.reports": "Laporan",
    "table.journey_type": "Jenis Perjalanan",
    "label.yes": "Ya",
    "pageTitle.assessor_report": "Laporan Assessor",
    "label.organization": "Organisasi",
    "notifications.award_leader_has_been_updated": "Award Leader telah mendapat pemutakhiran",
    "moduleTitle.edit_role": "Edit Peran",
    "table.journey_activity": "Kegiatan Perjalanan",
    "label.location": "Lokasi",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "Perjalanan Petualangan",
    "global.assessor": "Assessor",
    "moduleTitle.profile_questions": "Pertanyaan mengenai Profile",
    "activity.cannot_edit_activity_if_award_in_state": "Tidak dapat mengubah kegiatan bila Award masih dalam state",
    "moduleTitle.assessor_detail": "Info lengkap Assessor",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Saya memahami bahwa pada saat diterima untuk menjalankan Award di Award Centre, peserta akan menerima Record Book atau memperoleh akses untuk menggunakan Online Record Book (ORB). Peserta akan membaca seluruh persyaratan dari Award yang tertera pada Record Book atau ORB sebelum dimulainya kegiatan yang berhubungan dengan program Award. Saya memahami bahwa Award Centre memiliki kuasa penuh untuk menentukan apakah seluruh persyaratan telah dilengkapi dan apakah serta kapan waktu Award Bronze, Silver atau Gold akan diterbitkan. Saya memahami bahwa Award Operator mungkin menyediakan para peserta fasilitas asuransi yang amat terbatas, sehingga segala sesuatu yang berkenaan dengan kecelakaan pribadi dan mengenai kewajiban asuransi umum lainya dimulai sejak diterimaya kami sebagai peserta oleh Award Centre, kami bertanggung jawab untuk mendapatkan dan memelihara perlindungan kecelakaan pribadi yang berkaitan dengan peserta/ dan para orang Tua/Wali mereka.",
    "notifications.award_has_been_returned": "Award telah dikembalikan",
    "label.code_of_conduct": "",
    "button.new_contact": "Kontak baru",
    "tabs.payments": "Pembayaran",
    "roles.naa_oa_staff": "Staf Penyelenggara",
    "label.switch_organisation_hint": "Anda dapat membuka dialog ini kapan saja dengan memilih \" Tukar Organisasi\" dalam menu yang terletak di kanan atas",
    "label.expiration_date": "Tanggal Habis Waktu",
    "tabs.participants": "Peserta",
    "table.practice": "Ujicoba/Latihan",
    "notifications.one_activity_has_to_remain": "satu kegiatan dalam bidang wajib dipertahankan (tidak dihapus)",
    "label.qualifications": "Kualifikasi",
    "states.organization_approval": "Persetujuan Organisasi",
    "errors.must_be_an_integer": "Wajib merupakan bilangan bulat",
    "participant.send_confirmation_email_again_question": "Kirim email konfirmasi lagi?",
    "button.dismiss": "Berhenti",
    "table.advice": "",
    "label.years_of_working_experience": "Lama pengalaman bekerja",
    "notifications.search_failed": "Ada kesalahan pada saat searching. Harap coba sekali lagi",
    "notifications.changes_have_been_saved": "Perubahan telah disimpan",
    "moduleTitle.resend_parental_consent_link": "Mengirim link untuk persetujuan Ortu?",
    "label.activity_type": "Jenis kegiatan",
    "label.change_award": "Ubah tingkatan Award",
    "label.email": "Email",
    "button.remove": "Hilangkan",
    "button.download": "donlod",
    "label.vat_treatment": "Aplikasi VAT",
    "pageTitle.aj_template_new": "Perjalanan Petualangan yang baru - template",
    "table.per_page": "Per halaman",
    "notifications.translations_has_been_updated": "Notifikasi terjemahan telah dimutakhirkan",
    "notification.award_mode_has_been_updated": "Mode Award telah diperbaharui",
    "tasks.revise_item": "Perbaiki",
    "button.resend_parental_consent": "Mengirim kembali persetujuan Ortu",
    "table.weeks_completed_required": "Jumlah minggu yang diselesaikan/wajib",
    "label.last_modified": "Dimodifikasi terakhir",
    "table.major": "Utama",
    "label.vat_number": "No VAT",
    "errors.passwords_dont_match": "Kata sandi tidak cocok",
    "table.country": "Negara",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "Pertanyaan telah di perbaharui",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "Kode Otorisasi tidak lagi valid",
    "errors.must_be_no_more_than": "Wajib terdiri lebih dari {max} karakter",
    "notifications.event_has_been_rejected": "Kegiatan telah dikembalikan",
    "tabs.customizations": "Penyesuaian",
    "label.name_organization": "Nama",
    "button.add_log": "Tambahkan Catatan",
    "moduleTitle.invite_assessor": "Undang Assessor",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "Seluruh peserta akan dialihkan ke Award Leader baru",
    "label.repeat_email": "Ulangi email",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "Peran telah diperbaharui",
    "roles.if_staff_stat_user": "Bila merupakan Pengguna Statistik",
    "participant.delete_account": "Akun dihapus",
    "moduleTitle.would_you_like_to_remove_this_log": "Apakah kamu ingin menghapus catatan ini?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "Jenis Perjalanan",
    "sidebar.manual_data_import": "Import Data Manual",
    "label.created_after_date": "Dibuat setelah",
    "route.my_organization": "Organisasi",
    "button.show_list": "",
    "label.leaders": "Leaders",
    "notifications.log_has_been_modified": "Catatan telah dimodifikasi",
    "button.upload_file": "Upload Berkas",
    "moduleTitle.which_section_do_you_want_to": "Bidang mana yang akan kamu kembalikan pada status \"in progress\"?",
    "tabs.bronze_level": "Tingkat Perunggu",
    "notifications.participants_have_been_saved": "Peserta telah disimpan",
    "pageTitle.aj_template_detail": "Perjalanan Petualangan",
    "label.parent_email": "Email Ortu/Wali",
    "map.appr_location": "Alamat",
    "notifications.log_has_been_removed": "Catatan telah dihilangkan",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "",
    "button.stay": "Tetap dihalaman",
    "table.previous_level": "Tingkat sebelumnya",
    "label.award_start_date": "Tanggal mulai Award",
    "assessor_report.returned_to_participant": "Dikembalikan ke peserta",
    "pageTitle.tasks_assessors_registration": "Registrasi Assessor",
    "aj.cannot_modify_award": "Anda tidak dapat mengubah di tingkatan Award, bila peserta masih terdaftar di Kegiatan Perjalanan Petualangan",
    "moduleTitle.lost_internet_connection": "koneksi internet terganggu",
    "states.ceremony": "Upacara",
    "participant.reactivate_account": "Aktikan kembali akun",
    "label.birthdate": "Tanggal Lahir",
    "pageTitle.assessment_send_successfully": "Assesment telah berhasil dikirim",
    "states.assessor_approval": "Persetujuan Assessor",
    "award.change_award_level": "Ubah Tingkat Award",
    "label.url_no_longer_valid": "URL tidak berlaku",
    "button.update": "Update",
    "label.secondary_email": "Alamat email kedua",
    "button.role_edit": "Ubah/Perbaiki",
    "table.award_leader": "Award Leader",
    "label.level": "Tingkat",
    "tasks.evidence": "Bukti",
    "notifications.participant_is_already_in_list": "Peserta telah terdaftar",
    "button.clear": "Hapus",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Mulai susun",
    "table.activity": "Kegiatan",
    "label.copy_to_clipboard": "",
    "route.award_units": "Award Centre",
    "button.upload_photo": "Upload foto",
    "table.hours_completed_required": "Jam dihabiskan / diwajibkan",
    "table.first_name": "Nama depan",
    "notifications.adventurous_journey_has_been_returned": "Perjalanan Petualangan telah direvisi",
    "pageTitle.national_offices": "Kantor Award Nasional",
    "notifications.you_have_been_logged_in": "Kamu telah berhasil masuk",
    "logs.offline": "",
    "moduleTitle.add_role": "Tambahkan peran",
    "label.user_app_guide_participant": "Panduan Aplikasi user - peserta",
    "notifications.file_has_been_removed": "File telah dihilangkan",
    "label.send_message": "",
    "button.select": "Pilih",
    "label.reason_of_deletion": "Alasan penghapusan",
    "label.user_guide": "User guide",
    "pageTitle.nao_participants": "Kantor Nasional - Peserta",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Di Upload oleh",
    "tasks.approve_item": "Persetujuan ",
    "tasks.restore_participant_registration": "Simpan kembali Registrasi Peserta",
    "label.awardMode.hybrid": "HIbrida",
    "table.first_activity_started": "Kegiatan Awal dimulai",
    "moduleTitle.dates": "Tanggal",
    "table.no_results": "Tidak ada hasil",
    "states.registration_approval": "Persetujuan pada saat pendaftaran",
    "table.breakdown_of_hours": "Perincian lama waktu",
    "pageTitle.tasks_registration": "Registrasi Peserta",
    "button.create_new": "Buat baru",
    "sidebar.todolist": "Daftar kegiatan",
    "label.active_participants": "Peserta Aktif",
    "moduleTitle.postalAddress": "moduleTitle.alamat.pos",
    "tasks.return_task": "Tugas dikembalikan",
    "organisation.change_organisation_state": "Ubah Status Organisasi",
    "moduleTitle.roles": "Peran",
    "label.no_config_key_available": "Tidak ada kunci konfigurasi untuk bagian ini",
    "placeholder.selectLanguage": "placeholder.selectLanguage",
    "states.office_signoff": "Kantor Award memberikan persetujuan",
    "notifications.translations_has_been_updated.failure": "Notifikasi terjemahan telah dimutakhirkan kegagalan",
    "logs.minute": "menit",
    "label.last_activity": "Kegiatan sebelumnya",
    "sidebar.user_guide": "User Guide",
    "label.trained_award_leader": "Award Leader yang telah ikut pelatihan",
    "table.progress": "Progres",
    "table.suboperating_authorities": "Sub-Otorita Operasi",
    "activity.cannot_edit_activity_offline": "Peserta ini sedang menjalankan mode Offline, <br><br>. Anda tidak dapat melakukan perubahan; pada Kegiatan, Perjalanan Petualangan atau Proyek Pemukiman dalam kondisi semi-offline.",
    "label.user_does_not_have_permissions": "User tidak mendapat ijin untuk melihat isi catatan",
    "notifications.assessor_has_been_approved": "Assessor telah di setujui",
    "route.activity_approval": "Persetujuan atas kegiatan",
    "moduleTitle.role": "Peran",
    "button.run": "Lari",
    "label.to": "Untuk",
    "notifications.file_has_been_updated": "File telah diuploaded",
    "moduleTitle.edit_coordinator": "Ubah Coordinator",
    "notifications.authorization_code_is_no_longer_valid": "Kode Otorisasi tidak valid lagi",
    "button.reject": "Kembali",
    "label.label.participant_status": "Status peserta",
    "award.gold_level": "Tingkat Emas",
    "sidebar.variables": "Variabel",
    "parentalConsent.checkbox_copy": "Saya menyatakan bahwa saya adalah orang tua/wali dari {nama depan} {nama belakang}. Saya memberikan persetujuan untuk anak saya untuk berpartisipasi dalam program Award di {namaorganisasi} dibawah supervisi {awardLeader}. Saya telah membaca, memahami dan menyetujui semua persyaratan dan kondisi dari partisipasi anak saya dalam program Award, sebagaimana dijelaskan diatas dan pada website penyelenggara Award.",
    "button.go_to_dashboard": "Kembali ke beranda",
    "button.add_option": "tambahkan opsi",
    "label.is_completed": "Telah Lengkap",
    "pageTitle.award_units": "Award Centre",
    "states.completed": "Selesai",
    "button.adventurous_journey_template_settings": "Pengaturan Template Perjalanan Petualangan",
    "label.system_rights": "Hak dari System",
    "label.assessor_assesstment_award_start_date": "label.assessor_tanggal_mulai_assessment_award",
    "label.update_translation_question": "",
    "button.login": "Masuk",
    "label.name_of_the_unit": "Nama dari Award Centre",
    "button.send": "Kirim",
    "award.ajs": "Perjalanan Petualangan",
    "meta.payments_expired": "Pembayaran - kadaluwarsa",
    "label.age": "Umur",
    "notifications.payment_info_updated": "Informasi mengenai pembayaran telah di perbaharui",
    "table.is_completed": "Telah lengkap",
    "table.invited_by": "DIundang oleh",
    "route.files": "Berkas",
    "route.assessors": "Assesors",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "Daftar Peserta",
    "label.change_leader_status": "Ubah Status Leader",
    "moduleTitle.parent_consent_form": "Formulir Persetujuan Orang Tua / Wali",
    "notifications.authorization_contact_has_been_set": "Kontak Otorisasi telah ditetapkan",
    "button.close": "Tutup",
    "label.independent_country": "Negara",
    "notifications.aj_preparation_training_has_been_returned": "Persiapan dan Pelatihan Perjalanan Petualangan telah direvisi",
    "route.history_log": "Catatan Sejarah",
    "participant.account_settings": "Pengaturan Akun",
    "label.bulk_action_error_item": "",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "url tidak tersedia dalam konfigurasi",
    "notifications.award_unit_has_been_removed": "Award Centre/ IAC telah dihapus",
    "table.parent": "Orang tua",
    "label.mode_of_transport": "Jenis angkutan yang digunakan",
    "label.parental_consent_email_info": "Jangan lupa untuk melakukan check email para ortu dan kirimkan surat persetujuan secara manual ",
    "label.current_award": "Award saat ini",
    "table.action": "Aksi",
    "pageTitle.suboperating_authorities": "Sub-Otorita Operasi",
    "notifications.award_leader_has_been_assigned": "Award Leader telah ditugaskan",
    "tabs.sign_offs_locally": "disetujui (lokal)",
    "Activity log has been restored": "perhatian catatan telah disimpan",
    "sidebar.naos": "Kantor Award Nasional (NAO)",
    "tabs.aj_templates": "Template Perjalanan Petualangan",
    "notifications.logging_out": "Keluar",
    "label.update_label": "",
    "button.organisation_settings": "Pengaturan Organisasi",
    "tabs.independent_award_centers": "Independent Award Centres",
    "label.current": "Berlangsung",
    "table.location": "Lokasi",
    "button.search": "Cari",
    "notifications.aj_preparation_training_has_been_approved": "Persiapan dan Pelatihan Perjalanan Petualangan telah disetujui",
    "route.participants": "Peserta",
    "label.other_location_information": "Informasi mengenai Lokasi lain",
    "label.number_of_records": "Jumlah catatan",
    "translationsManagement.infoLabel": "Pengaturan terjemahan Label information ",
    "parentalConsent.i_consent_to_pay_all": "5. Saya setuju untuk membayar seluruh biaya dokter, bidan dan biaya rumah sakit dan biaya biaya yang terjadi atas nama peserta apabila sampai terjadi kecelakaan, luka, sakit atau kehilangan yang diderita oleh peserta pada saat menjalankan atau dalam perjalanan ke dan dari, kegiatan lainnya atau fungsi fungsi sehubungan dengan Award.",
    "label.nationality": "Nasionalisme",
    "states.approval": "Persetujuan",
    "notifications.something_went_wrong": "Ada yang salah dalam proses",
    "aj.practice": "Latihan",
    "label.addressLine2": "Alamat (Baris Kedua)",
    "label.please_leave_a_note": "Harap tinggalkan catatan",
    "placeholder.select": "Pilih",
    "label.observations": "Observasi",
    "label.aim": "Tujuan",
    "label.addressLine1": "Alamat (Baris Pertama)",
    "roles.aj_instructor": "Instruktur AJ",
    "meta.payments_waiting": "Pembayaran - Masa Tunggu",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "Instruksi",
    "moduleTitle.remove_customization_and_reset": "Hilangkan kepengaturan dan reset configurasi",
    "notifications.participant_registration_has_been_restored": "Registrasi peserta telah disimpan",
    "organisation.change_award_unit_mode": "Ubah jenis organisasi",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "Peserta telah dihapus",
    "label.language_settings": "Pengaturan Bahasa yang digunakan",
    "notifications.event_has_been_approved": "Kegiatan telah disetujui",
    "label.password": "Kata Sandi",
    "label.text": "Text",
    "table.observations": "Observasi",
    "notifications.participant_has_been_created": "Peserta telah dibuat",
    "table.note_for_al": "Catatan untuk Award Leader",
    "label.payment_confirmed": "Pembayaran telah dikonfirmasikan",
    "label.previous_completed_award_level": "Tingkat sebelumnya",
    "pageTitle.new_aj_event": "Kegiatan Perjalanan Petualangan baru",
    "label.backend": "label.backend",
    "label.relationship_to_participant": "Hubungan dengan peserta",
    "award.physical_recreation": "Rekreasi Fisik",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "Laporan Assessor ditolak",
    "label.supervisor_report": "Laporan Supervisor",
    "table.role": "Pearn",
    "route.user_guide_web_nao": "User web guide - NAO",
    "label.page_not_found": "404 - Page not found",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "File telah diuploaded",
    "moduleTitle.address": "Alamat",
    "moduleTitle.lead_coordinator": "Pimpinan Coordinator",
    "pageTitle.login": "Login",
    "label.frontoffice": "label.frontoffice",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "Proyek Pemukiman telah dibuat",
    "moduleTitle.award_unit": "Award Centre",
    "button.remove_file": "File dihapus",
    "moduleTitle.billing_address": "Alamat penagihan",
    "pageTitle.my_aj_events": "Kegiatan Perjalanan Petualangan saya",
    "route.tasks": "Tugas",
    "button.confirm": "Konfirm",
    "label.national_award_authority": "Attires Award Nasional",
    "label.independent_award_centre": "IAC",
    "award.generate_award_report": "Susun Laporan",
    "route.my_region_office_customization": "Kantor Regional - disesuaikan",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "Permohonan perubahan kata sandi telah dikirim",
    "tabs.detail": "Info Lengkap",
    "participant.change_participant_status": "ubah status peserta",
    "table.key": "key",
    "label.find_address": "Cari alamat",
    "notifications.assessor_has_been_rejected": "Assessor telah direvisi",
    "label.transfer_participants": "Pindahkan peserta",
    "button.continue_to_payment_gateway": "lanjut ke gerbang pembayaran",
    "notifications.participant_registration_has_been_removed": "Registrasi peserta telah di hapus",
    "moduleTitle.page_not_found": "404 - Page not found",
    "route.adventurous_journeys": "Perjalanan Petualangan",
    "states.registration_assessment": "Assessment pada saat pendaftaran",
    "heading.change_award_unit_mode": "Ubah Mode  Award Centre",
    "label.user_guide_web_nao": "User web guide - NAO",
    "tabs.silver_level": "Tingkat Perak",
    "table.paid_by": "Dibayarkan oleh",
    "label.your_report_has_been_successfully_sent": "Reportmu telah berhasil dikirimkan",
    "sidebar.my_organization": "Organisasi",
    "pageTitle.participants": "Para peserta",
    "notifications.preparation_training_has_been_updated": "Persiapan dan PElatihan telah diperbaharui",
    "moduleTitle.server_is_unreachable": "Server tidak dapat dijangkau",
    "label.last_activity_date": "",
    "award.bronze_level": "Tingkat Perunggu",
    "moduleTitle.award_units": "Award Centre",
    "table.completed": "Lengkap/selesai",
    "moduleTitle.revise_message": "Perbaiki pesan",
    "table.lastUsed": "Last used",
    "award.bronze_to_gold_level": "Tingkat Perunggu ke Emas",
    "button.change_password": "Rubah kata sandi",
    "label.nao_price": "Harga berlaku untuk NAO",
    "label.payment_state": "Status Pembayaran",
    "label.wwc_expired": "WWC telah expired",
    "label.award_office_signoff_date": "Tanggal persetujuan Kantor Award",
    "label.award_unit": "Award Centre",
    "award.gold_level_short": "Emas",
    "moduleTitle.other_info": "Informasi lainnya",
    "table.note": "Catatan",
    "label.search_by_email_first_or_last": "Telusuri by email, nama depan atau nama belakang",
    "tabs.history": "Sejarah",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "Peserta belum mendapat Award Leader",
    "table.main_award_leader": "Award Leader Utama",
    "parentalConsent.i_as_the_parent": "3. Saya memahami bahwa kegiatan tertentu dipandang berisiko tinggi dan bahwa kegiatan berisiko tinggi tersebut mungkin tidak semua dilindungi dengan asuransi oleh Operator Award. Saya memahami bahwa tanggung jawab atas semua risiko yang mungkin muncul dari partisipasi setiap peserta dalam Award merupakan tanggung jawab peserta sepenuhnya.",
    "label.state": "State (Negara)",
    "notifications.award_leader_has_been_removed": "Award Leader telah dipindahkan",
    "tabs.organization_detail": "info lengkap mengenai organisasi",
    "table.operating_authorities": "Otorita Operasi",
    "label.available_labels": "",
    "modal.select": "Pilih",
    "tabs.expired_payments": "Pembayaran Kadaluwarsa",
    "moduleTitle.note_for_al": "Catatan ini untuk Award Leader",
    "moduleTitle.confirm": "konfirm",
    "notification.new_activity_added": "Kegiatan baru telah ditambahkan",
    "notifications.award_leader_has_been_moved": "Award Leader telah dihapus",
    "label.award_mode": "Mode Award",
    "label.phone": "Telepon",
    "notifications.organization_has_been_updated": "Organisasi telah diperbarui",
    "moduleTitle.assessor": "Assessor",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "Persetujuan Orang Tua",
    "label.date_of_delivery": "Tanggal Pengiriman",
    "sidebar.assessors": "Assessors",
    "label.journey_activity": "Kegiatan dalam Perjalanan",
    "award.inactive_award": "Award tidak aktif",
    "label.end_date": "Waktu selesai ",
    "label.orb_testing": "",
    "label.no_activities": "tidak ada kegiatan",
    "moduleTitle.please_confirm": "mohon konfirmasi",
    "button.login_with_another_account": "Masuk dengan akun lain",
    "tasks.reject_registration": "Pendaftaran dikembalikan",
    "label.submitted_after_date": "Diserahkan berikutnya",
    "label.update_translations_successful": "",
    "button.assign_leader": "Leader yang bertugas",
    "table.already_running": "Telah berjalan",
    "label.no": "Tidak",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "No telepon kedua",
    "label.my_experience": "Pengalaman saya",
    "notifications.adventurous_journey_has_been_approved": "Perjalanan Petualangan telah disetujui",
    "pageTitle.mro_detail": "Info lengkap Kantor Regional",
    "moduleTitle.nao_specific_info": " Informasi spesifik dari Kantor Award Nasional",
    "label.preparing_document_for_import": "Siapkan dokumen untuk import",
    "tasks.observations": "Observasi",
    "notifications.confirmation_email_has_been_sent": "Email konfirmasi sudah dikirimkan",
    "button.restore": "Simpan",
    "label.importing_file": "Mengimpor file",
    "label.or_dont_agree": "atau tidak setuju? kamu bisa",
    "moduleTitle.award_leader": "Award Leader",
    "label.me": "ku",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "ekspor tabel",
    "organisation.move_award_unit": "Pindahkan Award Centre",
    "label.file_category": "",
    "notifications.connecting_to_server": "dihubungkna ke server",
    "parentalConsent.i_understand_that_a_and_b": "11. Saya memahami bahwa <br/> a. seorang peserta seharusnya tidak mengendarai motor atau mengantar perserta lain yang berpartisipasi dalam kegiatan award kecuali peserta memegang lisensi mengemudi yang cukup dan sah dan wajib dibarengi dengan asuransi pihak ketiga yang cocok tersedia untuk melindungi siapapum yang mungkin terluka akibat seorang peserta Award mengendarakan sesuatu. dan <br/> b. seorang peserta tidak disarankan dikemudikan oleh siapapun yang tidak terlibat atau membantu dalam mengelola Award, kecuali pribadi tersebut memiliki surat ijin mengemudi yang cocok dan sah, dilindungi dengan asuransi pihak ke tiga untuk melindungi siapapun yang mengalami luka sebagai akibat dari berkendaraan.",
    "table.reason": "",
    "pageTitle.contacts": "Kontak",
    "states.award_leader_approval": "Persetujuan Award Leader",
    "meta.payments": "Pembayaran",
    "label.suboperating_authority": "Sub-Otorita Operasi",
    "route.my_region_office": "Kantor Regionalku",
    "states.registration_not_approved": "Pendaftaran tidak disetujui",
    "label.direct_entrant": "Kepesertaan langsung",
    "tabs.all_participants": "Semua peserta",
    "tabs.payment": "Pembayaran",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "ulangi kata sandi",
    "label.other_roles": "",
    "logs.hours": "beberap ajam",
    "notifications.spreadsheet_has_been_imported_successfully": "File spreadsheet berhasil diimport",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "Info lengkap diri",
    "label.bulk_action_emailing": "",
    "route.my_events": "Acara",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "terdiri dari huruf kecil dan besar (kapital)",
    "tabs.removed_participant_registrations": "Hapur Registrasi Peserta",
    "sidebar.mynao": "Kantor Award Nasional (NAO)",
    "tabs.office_details": "Info lengkap kantor",
    "label.major": "Utama",
    "tabs.documents": "Dokumen",
    "label.new_password": "kata sandi baru",
    "sidebar.adventure_journey": "Perjalanan Petualangan",
    "pageTitle.customizations": "Penyesuaian",
    "moduleTitle.assessor_report": "{peran} laporan",
    "label.registration_date": "Tanggal Registrasi",
    "notifications.training_has_been_added": "Pelatihan telah ditambahkan",
    "aj.qualifying": "Kualifikasi",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Anda telah logged out karena session telah dihentikan",
    "award.service": "Layanan Masyarakat",
    "notifications.rp_state_has_been_changed": "Proyek Pemukiman telah diubah",
    "label.ctest_access": "",
    "table.created": "Dibuat",
    "tasks.revise_task": "Periksa tugas",
    "button.assign": "Tugas",
    "button.return": "Kembali",
    "table.status": "Status",
    "button.restore_activity": "Kembalikan Kegiatan",
    "tabs.new_aj_event": "Kegiatan Perjalanan Petualangan yang baru",
    "roles.if_staff_viewer": "Bila Staf Viewer",
    "notifications.new_template_has_been_created": "Template baru telah dibuat",
    "global.something_went_wrong": "Terjadi kesalahan",
    "table.expire_day": "Batas waktu",
    "tabs.history_log": "Sejarah Catatan",
    "label.form_of_payment": "Type dari pembayaran",
    "button.add_training": "Tambahkan pelatihan",
    "label.par_reg_cust_note": "Tab ini memungkinan anda mengatur kolom yang telah didisplay pada saat peserta melakukan registrasi dan dampaknya adalah jumlah data yang anda kumpulkan menjadi semakin banyak.\nHubungi Regional Office apa bila anda hal hal yang anda ingin ubah - karena hanya Sistem Admin yang memiliki access untuk melakukan perubahan.",
    "label.my_qualification": "Kualifikasi saya",
    "button.add_new_profile_question": "tambahkan pertanyaan pada profil baru",
    "table.operating_authority": "Operating Authority",
    "table.aim": "Tujuan",
    "table.awards": "Award",
    "participant.deactivate_account": "De aktifasi akun",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "Tanggal",
    "tasks.would_you_like_to_delete": "Apakah anda dapat menghapus peserta ini?",
    "notifications.configuration_value_has_been_updated": "konfigurasi nilai telah diperbarui",
    "ajTemplates.fill_from_template": "Lengkapi dari Template",
    "contact.send_test_email": "Kirim Email Percobaan ",
    "moduleTitle.aj_preparation_and_training": "Persiapan dan Pelatihan Perjalanan Petualangan",
    "label.ce_be": "",
    "button.notify_participant": "",
    "label.parent_phone": "No telpon Ortu/Wali",
    "label.nao_regulations": "",
    "award.skills": "Keterampilan",
    "label.reject_application": "tolak permohonan ini",
    "leader.delete_account": "Hapus Contact",
    "table.assign": "Penugasan",
    "roles.aj_supervisor": "Supervisor Perjalanan Petualangan",
    "label.logout": "Keluar",
    "moduleTitle.award_leader_edit": "Edir Award Leader",
    "moduleTitle.training": "Pelatihan",
    "notifications.coordinator_has_been_removed": "Coordinator telah dipindahkan",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Award Leader Utama / Coordinator",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "",
    "table.preparation": "Persiapan",
    "table.delete": "Hapus",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Laporan",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "Otorita Operasi",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "Konfirm",
    "notifications.invitation_has_been_sent": "Undangan telah dikirim",
    "pageTitle.independent_countries": "Independent Countries",
    "label.assessors_email": "Email Assessor",
    "tasks.approve_assessor_registration": "Registrasi Assessor disetujui",
    "table.award_duration": "Lama mengerjakan Award",
    "notifications.organization_has_been_moved": "Organisasi telah dipindahkan",
    "pageTitle.nao_payment": "Kantor Nasional - Pembayaran",
    "participant.history_log": "Sejarah catatan",
    "label.rejected_with_note": "",
    "label.already_running": "Telah berjalan",
    "button.continue": "tombol continue",
    "award.no_data_to_show": "Tidak ada data untuk ditampilkan",
    "participant.send_email_invitation_again_question": "Kirim email mengundang John CC May",
    "label.reason_for_changing_assessor": "Alasan mengganti Assessor",
    "button.delete": "Hapus",
    "moduleTitle.requirements_and_conditions": "Persyaratan dan Kondisi",
    "roles.leader": "Leader",
    "label.if_download_doesnt": "Bila donlot tidak dimulai secara otomatis, silahkan memeriksa apakah pengaturan popup ada dalam mesin pencarian anda",
    "dashboard.your_todo_list": "Daftar kegiatan",
    "notifications.award_unit_has_been_returned": "Award Centre telah direvisi",
    "moduleTitle.participant_activities": "Kegiatan peserta",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Leader yang aktif",
    "aj.preparation": "Persiapan",
    "button.change_state": "Rubah negara",
    "label.current_password": "kata sandi saat ini",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Pengaturan contact",
    "button.remove_photo": "Hapus foto",
    "notifications.activity_has_been_setup": "Kegiatan telah dibuat",
    "errors.must_be_more_than": "Harus lebih dari pada {limit}",
    "table.goal": "Tujuan",
    "notifications.coordinator_has_been_set": "Coordinator telah ditetapkan",
    "label.cc": "copy",
    "label.duration": "Lamanya ",
    "table.actions": "Aksi",
    "participant.send_email_invitation_again": "Ingin mengirimkan email undangan lagi?",
    "moduleTitle.would_you_like_to_remove_participant": "Apakah anda ingin menghapus peserta?",
    "parentalConsent.i_authorise_employees": "4. Saya memberikan otorisasi pada pegawai, staffs atau agen dari Award Centre dan semua pribadi terkait yang berpartisipasi, dan terlibat atau mebantu dalam mengorganisasikan program Award, apabila sampai terjadi kecelakaan yang tidak terhindarkan, luka, sakit, atau kehilangan/kerugian yang dialami oleh peserta yang sedang menjalankan program, atau melakukan perjalanan ke dan dari, atau kegiatan atau fungsi yang terkait dengan Award, untuk memperoleh bantuan medis yang cukup atau perawatan termasuk tapi tidak terbatas pada berhubungan dengan dokter, perawat atau akomodasi rumah sakit.",
    "button.reload_page": "Unggah Halaman",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "Email",
    "label.new_goal": "Tujuan yang baru",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Alamat email tidak valid",
    "pageTitle.new_contact": "Kontak yang baru",
    "sidebar.gops": "",
    "button.manage_participants": "Kelola Peserta",
    "errors.invalid_phone_format": "Nomor Telepon tidak valid",
    "notifications.login_details_have_been_changed": "Rincian login telah diubah",
    "moduleTitle.participant_logs": "Catatan Peserta",
    "label.save": "Simpan",
    "label.frequently_asked_questions": "QA",
    "label.city": "Kota",
    "notifications.configuration_value_has_been_reset": "Niai konfigurasi telah di reset",
    "states.office_sign_off": "Persetujuan dari Kantor Award",
    "button.save": "Simpan",
    "button.import_data_from_selected_file": "Import data dari file ttt",
    "parentalConsent.i_understand_that_the_participant_cannot": "9.Saya memahami bahwa peserta tidak dapat memulai kegiatan apapun dalam program Award sampai saya merasa cukup yakin bahwa para relawan yang di nominasikan oleh para peserta, yang mana bukan merupakan pegawai dari Award Centre, merupakan pribadi yang memiliki pengalaman dan atau memiliki kualifikasi cukup untuk menginstruksikan/membimbing/menilai bidang kegiatan Award; dan sampai semua relawan yang berkaitan dapat menyelesaikan perannya dan mengembalikan dokumen yang dibutuhkan kepada Award Centre.",
    "pageTitle.apiKeys": "Api Keys",
    "label.international_region": "Wilayah Internasional",
    "tabs.levels": "Tingkatan",
    "tabs.additional_files": "Berkas tambahan",
    "label.continuation_level": "Tingkat berikutnya",
    "table.adventurous_journey_detail": "Detail Perjalanan Petualangan",
    "button.set": "Atur",
    "label.i_certify_that_as_the_assessor": "Saya menyatakan bahwa kegiatan yang dilakukan oleh peserta telah memenuhi persyaratan",
    "table.coordinator": "Coordinator",
    "participant.send_confirmation_email_again": "Kirim email konfirmasi lagi?",
    "table.report": "Laporan",
    "label.update_translations_results": "",
    "table.observation_note": "Catatan observasi",
    "label.view_more": "Lihat lebih banyak",
    "notifications.payment_link_has_been_reset": "Link Pembayaran telah ditata secara ulang",
    "table.type": "Jenis",
    "moduleTitle.updateConfigurationKey": "update configures chunk",
    "sidebar.independent_award_centers": "Independen Award Center",
    "table.activity_type": "Jenis Kegiatan",
    "label.awardMode.online": "Online",
    "table.data_state": "Terakhir Refresh Data",
    "button.generate_report": "Buat Laporan",
    "moduleTitle.assessed_by_award_leader": "Dinilai oleh Award Leader",
    "table.child_protection_number": "Nomor Perlindungan Anak",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "Status Award",
    "moduleTitle.overview": "Ikhtisar",
    "table.aj_detail": "Detail mengenai Perjalanan Petualangan",
    "pageTitle.tasks_activity_approvals": "Persetujuan untuk kegiatan",
    "label.section": "Bidang",
    "route.history": "Sejarah",
    "route.event_participants": "Acara peserta",
    "participant.account_detail": "Pengaturan Account",
    "route.dashboard": "Panel",
    "table.payments": "Pembayaran",
    "pageTitle.profile": "Profil",
    "organisation.remove_organisation": "Hapus Organisasi",
    "pageTitle.my_organization": "Organisasi ku",
    "label.award_leader": "",
    "notifications.assessor_has_been_updated": "Assessor telah di perbarahui",
    "label.participant_personal_reflection": "",
    "button.add_key": "Add key",
    "header.appMotto": "DUKE",
    "table.qualifying": "Untuk Kualifikasi",
    "button.upload": "Upload",
    "button.resend": "Kirim Kembali",
    "label.filename": "Nama File",
    "label.change_parental_consent": "",
    "button.cancel": "Batal",
    "label.aply_to_all_langs": "",
    "route.customization": "Disesuaikan dengan kebutuhan",
    "errors.minimal_duration_is": "Minimal lama waktu adalah 30 menit",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "Status Peserta",
    "award.bronze_level_short": "Perunggu",
    "label.phone_type": "Tipe Pohon",
    "global.night": "malam",
    "button.adventurous_journey_settings": "Pengaturan Perjalanan Petualangan",
    "participant.leader_must_be_selected": "Leader perlu dipilih",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "User menambahkan Persiapan dan Pelatihan ",
    "table.approve": "Disetujui",
    "label.role_in_organisation": "Peran dalam Organisasi",
    "states.finished": "Selesai",
    "label.created": "Dibuat",
    "button.back_to_home": "kembali",
    "label.options": "Opsi",
    "contact.next_level_invitation": "Undangan ke tingkat berikutnya",
    "moduleTitle.activity_detail": "Info Lengkap Kegiatan",
    "route.section_signoff": "Persetujuan atas Bidang Kegiatan",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Pengaturan kontak",
    "label.transation_id": "Transasksi ID",
    "notifications.activity_has_been_updated": "Kegiatan telah berhasil di perbaharui",
    "sidebar.awards": "Award",
    "parentalConsent.images_consent": "Sebagai orang tua/wali, saya memberikan persetujuan pada image yang akan digunakan oleh Yayasan untuk keperluan promosi.",
    "participant.would_you_like_to_delete": "Apakah kamu ingin mendelete akun ini",
    "roles.user": "User",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "Tidak ada hasil",
    "moduleTitle.address_line_2": "Alamat line 2",
    "states.awaiting_office_sign_off": "Menunggu Kantor Award memberikan persetujuan",
    "moduleTitle.export": "Ekspor",
    "moduleTitle.address_line_1": "Alamat line 1",
    "notifications.participant_has_been_assigned": "Peserta telah memperoleh Leader",
    "roles.viewer": "Viewer/Pemerhati",
    "label.participants_total": "Total peserta",
    "errors.auth_code_is_no_longer_valid": "Kode otorisasi tidak valid lagi - telah digunakan atau telah habis masa berlaku",
    "label.file_is_not_available": "FIle tidak tersedia",
    "button.select_template": "Pilih Template",
    "label.payment": "Pembayaran",
    "award.silver_level_short": "Perak",
    "table.participant_id": "",
    "text.hours_old": "{hours} jam",
    "moduleTitle.your_personal_information": "Informasi pribadi",
    "aj.minimum_date_recommendation": "Tanggal minimum yang direkomendasikan untuk berlatih AJ dan {nama} adalah",
    "label.date_of_payment": "Tanggal Pembayaran",
    "button.view": "LIhat",
    "label.create_new_label": "",
    "title.confirmation": "",
    "button.set_participants": "Atur Peserta",
    "roles.assessor": "Assessor",
    "moduleTitle.coordinator_settings": "Atur Coordinator",
    "label.parent_relationship": "Hubungan",
    "table.nao": "National Award Office / Kantor Award Nasional",
    "notifications.email_has_been_sent": "Email telah dikirim",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "Sub-Otorita Operasi",
    "route.award": "Award",
    "label.no_roles": "Tidak ada peran",
    "table.files": "Berkas",
    "aj.minimum_date_requirements": "Persyaratan minimum untuk Perjalanan Bertualang untuk kualifikasi adalah",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "Peserta sedang Offline",
    "moduleTitle.other_coordinators": "Coordinator lain",
    "button.updateSelectedLanguage": "button.updateBahasaPilihan",
    "tasks.approve_award_registration": "Pendaftaran Award disetujui",
    "participant.invite_participant_to_next_level": "Undang peserta ketingkat berikutnya",
    "label.twitter": "Tweeter",
    "pageTitle.awards": "Award",
    "warning.award_marked_as_paid": "",
    "table.edit": "Ubah",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "International Award",
    "moduleTitle.after_assigning_a_role_to_yourself": "Setelah menugaskan atau pindahkan role untk anda; anda perlu melakukan login sekali lagi",
    "label.transaction_id": "Identitas transaksi",
    "table.suboperating_authority": "Sub-Operating Authority",
    "label.participant_survey": "Sebagai Peserta Award, saya senang berpartisipasi dalam Survey yang diselenggarakan Yayasan",
    "label.created_by": "Dibuat oleh",
    "button.send_confirmation_email_again_question": "Kirimkan kembali email konfirmasi",
    "label.email_help_award_leader_email": "",
    "label.name": "Nama",
    "tabs.gold_level": "Tingkat Emas",
    "pageTitle.award_documents": "Dokumen Award",
    "label.online_payments": "Pembayaran via online",
    "label.child_protection_number": "No Perlindungan Anak",
    "participant.send_password_recovery_email": "Kirim kata kunci untuk membuka email untuk pemulihan",
    "notifications.new_log_has_been_added": "Catatan baru telah ditambahkan",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Nama Organisasi",
    "pageTitle.my_organization_templates": "Organisasi ku - template",
    "pageTitle.award_leaders": "Para Award Leader",
    "label.status": "Status",
    "label.street": "Jalan",
    "roles.if_staff_superuser": "Bila Staf Superuser",
    "table.licence_holder": "Pemegang lisensi",
    "label.created_at": "Dibuat di",
    "table.section": "Bidang",
    "table.system_rights": "Hak Sistim",
    "label.iac_type": "Jenis IAC",
    "label.other": "Lainnya",
    "moduleTitle.login": "Masuk",
    "label.no_data_to_show": "Tidak ada data yang dapat diperlihatkan",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Anda tidak dapat mengubah di tingkatan Award, bila peserta masih terdaftar di Kegiatan Perjalanan Petualangan",
    "tabs.waiting_payments": "Menunggu Pembayaran",
    "global.supervisor": "Supervisor",
    "notifications.new_role_has_been_added": "Role baru telah di tambahkan",
    "award.silver_level": "Tingkat Perak",
    "heading.change_awards_mode": "Ubah Mode Award",
    "button.save_changes": "Simpan perubahan",
    "organisation.would_you_like_to_move_award_unit": "Kemana anda akan memindahkan organisasi ini?",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "Kantor Regional - info lengkap",
    "table.started_at": "Dimulai",
    "parentalConsent.i_consent_to_the_award_unit": "2. Saya menyetujui Award Centre dan para pribadi lainnya, termasuk para relawan/volunteer*, yang terlibat didalam atau membantu mengorganisasikan program Award dan termasuk pengemudi yang dipekerjakan, untuk mengantar peserta untuk melakukan kegiatan atau fungsi yang terkait dengan program award, sesuai dengan kebutuhannya. Saya memahami bahwa Award Centre akan memberitahukan kepada saya sebelumnya kapan dan kemana perjalanan akan dilakukan.",
    "logs.minutes": "Menit",
    "label.total_participants": "Total Peserta",
    "moduleTitle.contact_info": "Informasi mengenai kontak",
    "table.payment_link": "Tautan Pembayaran",
    "errors.please_contact_your_local_award_staff": "Mohon hubungi Staf Award di negara anda"
}